import React from "react";
import PropTypes from "prop-types";

const VERSION = process.env.REACT_APP_VERSION;
const APP_ENV = process.env.REACT_APP_ENV; // DEV / UAT / PROD
const isDevEnv = APP_ENV === "DEV";

const Footer = ({ variant = "default" }) => {
  return (
    <div className={`app-footer app-footer-${variant}`}>
      {isDevEnv && <div className="footer-env">GetSigned 2026</div>}
      <div className="footer-version">Version: {VERSION}</div>
    </div>
  );
};

Footer.propTypes = {
  variant: PropTypes.string,
};

export default Footer;